// Derive current step from URL path with A/B test flow awareness
import { useLocation } from 'react-router-dom';
import { useOrderStore } from '@/stores/orderStore';
import { FLOW_STEP_LABELS, FLOW_ROUTE_TO_STEP } from '@/config/abTest';

// Legacy export for backwards compatibility (uses Flow A labels)
export const STEP_LABELS = FLOW_STEP_LABELS.A;

export function useCurrentStep(): number {
  const location = useLocation();
  const flowType = useOrderStore((state) => state.flowType);
  const path = location.pathname;

  const routeToStep = FLOW_ROUTE_TO_STEP[flowType];

  // Handle dynamic routes like /plan-options/:planId
  if (path.startsWith('/plan-options')) {
    return routeToStep['/plan-options'] ?? 3;
  }

  return routeToStep[path] ?? 1;
}

// Hook to get step labels based on current flow type
export function useStepLabels(): string[] {
  const flowType = useOrderStore((state) => state.flowType);
  return FLOW_STEP_LABELS[flowType];
}
